import { stripAnsi } from '@cli-utils/text.js'

export function shouldSuppressDevServerStartupLine(line: string): {
  suppress: boolean
  isReadyLine: boolean
} {
  const plain = stripAnsi(line).trim()

  if (plain.length === 0) {
    return { suppress: true, isReadyLine: false }
  }

  if (plain.includes('Ready in ')) {
    return { suppress: true, isReadyLine: true }
  }

  if (
    plain.startsWith('> ') ||
    plain.startsWith('$ ') ||
    plain.startsWith('▲ Next.js ') ||
    plain.startsWith('- ') ||
    plain.startsWith('· ') ||
    plain.startsWith('⨯ ')
  ) {
    return { suppress: true, isReadyLine: false }
  }

  if (plain.startsWith('✓ ') && !plain.includes('Ready in ')) {
    return { suppress: true, isReadyLine: false }
  }

  return { suppress: false, isReadyLine: false }
}
